<template>
  <div class="login-page">
    <div class="login-page__content" style="width: 100%">
      <div class="login-page__inner">
        <div class="login-inner">
          <div class="d-flex justify-content-center">
            <router-link to="/">
              <Logo />
            </router-link>
          </div>

          <div class="login-inner__nav mb-4">
            <div class="login-inner__nav-item active">
              <div class="login-title">Создать учетную запись компании/ИП</div>
              <div class="login-hr"></div>
            </div>
          </div>

          <div v-if="error" class="login-alert p-3 text-center mb-3">
            <div class="text-primary">Ошибка!</div>
            <span v-html="error"></span>
          </div>

          <ui-input-box-floating class="mb-3" :error="errors.name">
            <ui-input
              v-model="name"
              placeholder="Наименование предприятия"
              type="text"
              disabled
            />
            <ui-input-label>Наименование предприятия</ui-input-label>
          </ui-input-box-floating>

          <ui-input-box-floating class="mb-3" :error="errors.inn">
            <ui-input v-model="inn" placeholder="ИНН" type="text" disabled />
            <ui-input-label>ИНН</ui-input-label>
          </ui-input-box-floating>

          <ui-input-box-floating class="mb-3" :error="errors.lastname">
            <ui-input v-model="lastname" placeholder="Фамилия" type="text" />
            <ui-input-label>Фамилия</ui-input-label>
          </ui-input-box-floating>

          <div class="row">
            <div class="col">
              <ui-input-box-floating class="mb-3" :error="errors.firstname">
                <ui-input v-model="firstname" placeholder="Имя" type="text" />
                <ui-input-label>Имя</ui-input-label>
              </ui-input-box-floating>
            </div>

            <div class="col">
              <ui-input-box-floating class="mb-3" :error="errors.patronymic">
                <ui-input
                  v-model="patronymic"
                  placeholder="Отчество"
                  type="text"
                />
                <ui-input-label>Отчество</ui-input-label>
              </ui-input-box-floating>
            </div>
          </div>

          <ui-input-box-floating class="mb-3" :error="errors.email">
            <ui-input v-model="email" placeholder="E-mail" type="text" />
            <ui-input-label>E-mail</ui-input-label>
          </ui-input-box-floating>

          <ui-input-box-floating class="mb-3" :error="errors.phone">
            <ui-input
              v-model="phone"
              placeholder="Номер телефона"
              type="text"
            />
            <ui-input-label>Номер телефона</ui-input-label>
          </ui-input-box-floating>

          <PrivacyPolicy />

          <div class="d-flex gap-2">
            <ui-button
              @click="login"
              :loading="loading"
              class="btn-base btn-large"
              >Продолжить</ui-button
            >
            <ui-button
              @click="logout"
              :disabled="loading"
              class="btn-ghost btn-large"
              >Выйти</ui-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Logo from "@/assets/svg/LogoLogin.vue";

import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";

import { postApi } from "@/run";
import PrivacyPolicy from "./components/PrivacyPolicy.vue";

const router = useRouter();
const route = useRoute();
const store = useStore();

const loading = ref(false);
const error = ref(null);
const errors = ref([]);
// const email = ref(null);
const password = ref(null);

const logout = () => {
  store.commit("main/setLoading", true);
  postApi("/logout", {}).then((res) => {
    if (res.status) {
      store.commit("main/setNewUser", false);
    }
    store.commit("main/setLoading", false);
  });
};

const name = ref("");
const inn = ref("");
const lastname = ref("");
const firstname = ref("");
const patronymic = ref("");
const email = ref("");
const phone = ref("");

onMounted(() => {
  document.title = "Создать учетную запись компании/ИП - STONE-XXI";

  // получаем данные через геттер
  const newUser = store.getters["main/getNewUser"];

  if (newUser && typeof newUser === "object") {
    name.value = newUser.name || "";
    inn.value = newUser.inn || "";
    email.value = newUser.email || "";
    phone.value = newUser.phone || "";
  }
});

const login = async () => {
  loading.value = true;

  try {
    const response = await postApi("/create", {
      name: name.value,
      inn: inn.value,
      lastname: lastname.value,
      firstname: firstname.value,
      patronymic: patronymic.value,
      email: email.value,
      phone: phone.value,
    });

    if (response.error) {
      error.value = response.error;
      errors.value = response.errors ? response.errors : [];
    }

    if (response.status) {
      store.commit("main/setData", response.root);
      store.commit("main/setRoot", true);

      // if (response.root && response.root.leasingId) {
      //   // router.push("new");
      //   return router.push({
      //     name: "leasings.leasing.item",
      //     params: { id: response.root.leasingId },
      //   });
      // }
      if (response.root && response.root.leasingId) {
        // router.push("new");
        return router.push({
          name: "leasings.leasing.item",
          params: { id: response.root.leasingId },
        });
      } else {
        router.push("main");
      }
    }

    // if (response.calcID) {
    //   router.push("new");
    // }
  } finally {
    loading.value = false;
  }
};
</script>
